var map = {
	"./0.svg": 369,
	"./1.svg": 370,
	"./10.svg": 371,
	"./100.svg": 372,
	"./11.svg": 373,
	"./12.svg": 374,
	"./13.svg": 375,
	"./14.svg": 376,
	"./15.svg": 377,
	"./16.svg": 378,
	"./17.svg": 379,
	"./18.svg": 380,
	"./19.svg": 381,
	"./2.svg": 382,
	"./20.svg": 383,
	"./21.svg": 384,
	"./22.svg": 385,
	"./23.svg": 386,
	"./24.svg": 387,
	"./25.svg": 388,
	"./26.svg": 389,
	"./27.svg": 390,
	"./28.svg": 391,
	"./29.svg": 392,
	"./3.svg": 393,
	"./30.svg": 394,
	"./31.svg": 395,
	"./32.svg": 396,
	"./33.svg": 397,
	"./34.svg": 398,
	"./35.svg": 399,
	"./36.svg": 400,
	"./37.svg": 401,
	"./38.svg": 402,
	"./39.svg": 403,
	"./4.svg": 404,
	"./40.svg": 405,
	"./41.svg": 406,
	"./42.svg": 407,
	"./43.svg": 408,
	"./44.svg": 409,
	"./45.svg": 410,
	"./46.svg": 411,
	"./47.svg": 412,
	"./48.svg": 413,
	"./49.svg": 414,
	"./5.svg": 415,
	"./50.svg": 416,
	"./51.svg": 417,
	"./52.svg": 418,
	"./53.svg": 419,
	"./54.svg": 420,
	"./55.svg": 421,
	"./56.svg": 422,
	"./57.svg": 423,
	"./58.svg": 424,
	"./59.svg": 425,
	"./6.svg": 426,
	"./60.svg": 427,
	"./61.svg": 428,
	"./62.svg": 429,
	"./63.svg": 430,
	"./64.svg": 431,
	"./65.svg": 432,
	"./66.svg": 433,
	"./67.svg": 434,
	"./68.svg": 435,
	"./69.svg": 436,
	"./7.svg": 437,
	"./70.svg": 438,
	"./71.svg": 439,
	"./72.svg": 440,
	"./73.svg": 441,
	"./74.svg": 442,
	"./75.svg": 443,
	"./76.svg": 444,
	"./77.svg": 445,
	"./78.svg": 446,
	"./79.svg": 447,
	"./8.svg": 448,
	"./80.svg": 449,
	"./9.svg": 450,
	"./Medal-1.svg": 203,
	"./Medal-2.svg": 204,
	"./Medal-3.svg": 205,
	"./supervillain.svg": 451,
	"./zombie.svg": 452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;